<template>
  <div id="main">
    <v-index>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>实训</el-breadcrumb-item>
        <el-breadcrumb-item><a style="color: #000000;">检查登记</a></el-breadcrumb-item>
      </el-breadcrumb>

      <v-weburl-iframe url="train/check/index" />
    </v-index>
  </div>
</template>

<script>
import VIndex from "@/components/common";
import VWeburlIframe from "@/components/weburl-iframe";
export default {
  name: 'TrainGet',
  components: {VWeburlIframe, VIndex}
}
</script>

<style scoped>

</style>
